import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { ConnectedProps, connect, useSelector } from "react-redux";

import { getFlowSpeedLayer, setFlowSpeedLayer } from "./../state/layerCalculationMenu";
import LayerSubMenu from "./LayerSubMenu";
import WaterFlowSettingItem from "./WaterflowSettingItem";

const LayerMenuCalculationLayerWaterflows: React.FC<ConnectedProps<typeof connector>> = (props) => {
  const flowLayer = useSelector(getFlowSpeedLayer);

  const currentLayerVisible = flowLayer.visible;

  const [showFlowSettings, setShowFlowSettings] = useState(false);

  const formattedMessageColorPicker = (
    <FormattedMessage id="model.color_picker" defaultMessage="Color Picker" />
  );
  const formattedMessageLayerName = (
    <FormattedMessage id="layerMenu.flow_velocity_title" defaultMessage="Flow Velocity (1D)" />
  );

  const colorPickerHeader = (
    <div>
      {formattedMessageColorPicker}
      {": "}
      {formattedMessageLayerName}
    </div>
  );

  return (
    <>
      <LayerSubMenu.Item
        active={currentLayerVisible}
        title={"Flow Velocity (1D)"}
        onClick={() => {
          props.setFlowSpeedLayer({ visible: !currentLayerVisible });
          if (currentLayerVisible) setShowFlowSettings(false);
        }}
      >
        <LayerSubMenu.Item.Name>{formattedMessageLayerName}</LayerSubMenu.Item.Name>
        <LayerSubMenu.OpenSubMenuButton
          active={showFlowSettings}
          onClick={() => {
            setShowFlowSettings(!showFlowSettings);
            if (!showFlowSettings) props.setFlowSpeedLayer({ visible: true });
          }}
        />
      </LayerSubMenu.Item>

      {showFlowSettings && (
        <>
          <WaterFlowSettingItem
            title="Set the color of the flow animation"
            label="Color"
            colorPickerHeader={colorPickerHeader}
            defaultValue={flowLayer.color}
            onChange={(value: string) => props.setFlowSpeedLayer({ color: value })}
          />
          <WaterFlowSettingItem
            title="Set the speed of the flow animation"
            label="Speed"
            slider
            defaultValue={flowLayer.speedPercentage}
            onChange={(value: number) => props.setFlowSpeedLayer({ speedPercentage: value })}
          />
          <WaterFlowSettingItem
            title="Flow animation is not shown if velocity is below this value"
            label="Min velocity"
            defaultValue={flowLayer.waterflowThreshold}
            onChange={(value: number) => props.setFlowSpeedLayer({ waterflowThreshold: value })}
          />
          <WaterFlowSettingItem
            title="Flow animation is highlighted in purple if velocity is above this value"
            label="Highlight above"
            defaultValue={flowLayer.waterflowHighlightThreshold}
            onChange={(value: number) =>
              props.setFlowSpeedLayer({ waterflowHighlightThreshold: value })
            }
          />
        </>
      )}
    </>
  );
};

const connector = connect(null, {
  setFlowSpeedLayer,
});

export default connector(LayerMenuCalculationLayerWaterflows);
